import { Injectable } from '@angular/core';
import { Theme } from 'src/app/models/theme';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private static DEFAULT_THEME = Theme.Light;
  private _currentTheme = ThemeService.DEFAULT_THEME;

  constructor() { }

  set(theme: Theme) {
    document.body.classList.remove(this._currentTheme);
    this._currentTheme = theme;
    document.body.classList.add(theme);
  }

  remove() {
    document.body.classList.remove(this._currentTheme);
    this._currentTheme = ThemeService.DEFAULT_THEME;
  }

  get defaultTheme(): Theme {
    return ThemeService.DEFAULT_THEME;
  }

  get currentTheme(): Theme {
    return this._currentTheme;
  }

  get isDarkTheme(): boolean {
    return this._currentTheme === Theme.Dark;
  }

  get isLightTheme(): boolean {
    return this._currentTheme === Theme.Light;
  }
}
